import { IEmployeeSubscription, EmployeesService } from "../../services/index";

interface IResolve {
}

class SubscriptionItemController implements ng.IComponentController {
    private resolve: IResolve;
    private employeeId: string;
    private subscriptionId: string;
    private subscription: IEmployeeSubscription;

    constructor(
        private EmployeesService: EmployeesService,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService,
        private $timeout: ng.ITimeoutService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.employeeId = this.$stateParams["employeeId"];
        this.EmployeesService.getChild(this.employeeId, 'subscriptions').then((result: any) => {
            var subscriptions = result;
            this.subscription = subscriptions.find(s => s.id == this.$stateParams["subscriptionId"]);
        });
    }

    public submitSubscription() {
        if (this.subscription.id === undefined) {
            this.EmployeesService.postChild(this.subscription, this.employeeId, 'subscriptions').then((data) => {
                this.closeModal();
            });
        } else {
            this.EmployeesService.putChild(this.subscription, this.employeeId, 'subscriptions', this.subscription.id).then((data) => {
                this.closeModal();
            });
        }
    }

    delete() {
        this.EmployeesService.deleteChild(this.subscription.id, this.employeeId, 'subscriptions').then((data) => {
            this.closeModal();
        });
    }

    private closeModal() {
        this.$state.go('^', {}, {reload: true});
    }
}

export const subscriptionItemComponent: ng.IComponentOptions = {
    bindings: {
        resolve: '<'
    },
    controller: SubscriptionItemController,
    template: <string>require('./subscription.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/schedule/subscription.component.ts